import { StudentProxyType } from '@peekapak/types/DataProtocolTypes';

export const isParentsEmailSet = (student: StudentProxyType) =>
  !(
    student?.listOfParentProxies === undefined ||
    student?.listOfParentProxies.length === 0 ||
    student?.listOfParentProxies[0].email === undefined ||
    student?.listOfParentProxies[0].email === ''
  );

export const isTooSoonToEnableResend = (student: StudentProxyType) => {
  const epoch = (() => {
    const lastSendDate = student?.listOfParentProxies[0]?.invitationStatus?.lastSendDate;
    if (!lastSendDate) {
      // ensures that resend will be flagged as true
      return 0;
    }

    // at some point, someone wrote code that converted the lastSendDate to a string
    // so we have to handle that case
    if (typeof lastSendDate === 'string') {
      return parseInt(student.listOfParentProxies[0].invitationStatus!.lastSendDate as unknown as string, 10);
    }

    return student.listOfParentProxies[0].invitationStatus!.lastSendDate!;
  })();

  const now = new Date().getTime();

  const differenceInSeconds = Math.abs(epoch - now) / 1000;
  return differenceInSeconds < 10;
};

export const isInvitationSendPending = (student: StudentProxyType, sendPendingList: string[]) => {
  const toSendPid = student.listOfParentProxies[0].pid;

  return sendPendingList.includes(toSendPid);
};

export const isSpecificStatus = (student: StudentProxyType, status: string) =>
  student.listOfParentProxies !== undefined &&
  student.listOfParentProxies.length > 0 &&
  student.listOfParentProxies[0].invitationStatus !== undefined &&
  student.listOfParentProxies[0].invitationStatus.status === status;

export const isInvitationHasBeenSent = (student: StudentProxyType) =>
  isSpecificStatus(student, 'Sent') ||
  (student.listOfParentProxies !== undefined &&
    student.listOfParentProxies.length > 0 &&
    student.listOfParentProxies[0].invitationStatus !== undefined &&
    student.listOfParentProxies[0].invitationStatus.lastSendDate !== undefined);

export const isInvitationAccepted = (student: StudentProxyType) => isSpecificStatus(student, 'Accepted');

export const isInvitationDeclined = (student: StudentProxyType) => isSpecificStatus(student, 'Declined');

export const isOptedOut = (student: StudentProxyType) => isSpecificStatus(student, 'OptedOut');
